import React from "react";
import UnderConstruction from "../components/UnderConstruction";

const EventsPage = () => {
  return (
    <UnderConstruction 
      title="Events & Webinars"
      description="We're building an exciting events platform featuring webinars, workshops, and networking opportunities for conscious business leaders."
      expectedLaunch="Q2 2025"
    />
  );
};

export default EventsPage;